import ReadonlyRating from '@modules/common/components/readonly-rating';
import { YelpLogoWhite } from '@modules/common/components/yelp-logo/yelp-logo-white';
import { Coordinates, Location } from 'types/business';
import { CHOOSE_YOUR_OWN, LET_THEM_CHOOSE, SearchService } from '@lib/constants/variants';
import { GiftCardTypes } from './giftcard-type';
import { GoogleRating } from '@modules/common/components/google-rating';
import { GoogleLogo } from '@modules/common/components/google-logo';
import { useSearchService } from '@lib/context/search-service-context';
import { H1 } from '@modules/common/components/typography/H1';

type Props = {
  id?: string;
  rating: number;
  review_count: number;
  name: string;
  location: Location;
  phone: string;
  coordinates: Coordinates;
  distance: number;
  url: string;
  search_provider: string;
};

const MediumGiftCardInformationInPhoto = ({ ...props }: Props) => {
  const { rating, review_count, name, url, id, search_provider } = props;
  const searchService = useSearchService();

  return (
    <div className="flex justify-between items-start">
      <div>
        {name === LET_THEM_CHOOSE ? (
          <H1 className="text-[32px] uppercase">{CHOOSE_YOUR_OWN}</H1>
        ) : (
          <H1 className={`!text-[32px] ${!id ? 'uppercase' : ''}`}>{name}</H1>
        )}
        {name === LET_THEM_CHOOSE ? <GiftCardTypes /> : ''}
      </div>
      {!searchService?.loading && (
        <div className="flex flex-col items-end">
          {id && (
            <>
              <a href={url} target="blank" aria-label="go to business" className="flex items-center gap-2">
                {search_provider === SearchService.YELP ? (
                  <ReadonlyRating count={rating} size="1rem" />
                ) : (
                  <GoogleRating count={rating} size="1rem" />
                )}
                <span>{review_count}</span>
              </a>
              <div className="flex space-x-1 items-center justify-end">
                <a href={url} target="blank">
                  <span className="flex text-white items-center">
                    <span className="text-[10px] mr-0.5 mt-1">on </span>
                    <span>{search_provider === SearchService.YELP ? <YelpLogoWhite /> : <GoogleLogo />}</span>
                  </span>
                </a>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MediumGiftCardInformationInPhoto;
